import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import RegisterFormPremium from "../../../components/RegisterFormPremium";
import { CactusModal } from "../../../components/";
import { replace } from "connected-react-router";


import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../../actions";

interface RegisterProps {};

const Register: React.FC<RegisterProps> = (props: RegisterProps) => {

    const [t] = useTranslation();

    const dispatch = useDispatch();
    const { isLoading } = useSelector( (store: any) => store.authReducer);
    const [showCactusModal, setShowCactusModal] = useState<boolean>(false);

    return(
        <>
            <div className="auth">
                <div className='box-center'>

                    <div className='auth__wrapper'>
                    <div className='auth__box auth__box--large'>
                        <div className="row">

                            <div className="col-12 col-md-6">
                                <div className="d-flex h-100 justify-content-center align-items-center">
                                    <img className="auth__logo" src={process.env.REACT_APP_AUTH_LOGO_URI || '/img/logo-cactus.png'} alt="logo" />
                                </div>
                            </div>

                            <div className="col-12 col-md-6 auth__form">
                                <p className="auth__heading">{t('register_welcome')}</p>
                                <p className="auth__subheading">{t('register_subtitle')}</p>
                                <RegisterFormPremium
                                    btnLoading={isLoading}
                                    onSubmit={(newUser) => {
                                        dispatch( actionCreator.userCreate(newUser, (success: boolean) => {
                                            if(success) {
                                                setShowCactusModal(true);
                                            }
                                        }) );
                                    }}
                                />
                            </div>

                        </div>
                    </div>

                    <p className="auth__register-hint">
                        {t('register_have_account')}{' '}
                        <Link to="/login">{t('register_login_link')}</Link>
                    </p>
                    </div>

                </div>
            </div>

            <CactusModal 
                show={showCactusModal}
                //title={t('Create User')}
                onClose={() => {
                    setShowCactusModal(false);
                    dispatch( replace('/login'));
                }}
                width="70vw"
            >
                <p>{t('Wait to be validated by the administrator')}</p>
            </CactusModal>

        </>
    );

};

export default React.memo(Register);
